// extracted by mini-css-extract-plugin
export var badge = "_hl-2";
export var detailsPanel = "_hl-0";
export var resultRow = "_hl-1";